import './SiteHeader.scss';

import { Client } from '@amityco/ts-sdk';
import { useCreateAmityClient } from 'hooks/useCreateAmityClient';
import { useLoadPromoBanner } from 'hooks/useLoadPromoBanner';
import { useLoadSiteHeader } from 'hooks/useLoadSiteHeader';
import { observer } from 'mobx-react-lite';
import { Header, PromoBanner } from 'petdna-lib-uicomponents/components';
import { usePatchLibUIComponentsContext } from 'petdna-lib-uicomponents/hooks';
import React, { useEffect, useMemo, useState } from 'react';
import { useMatch, useSearchParams } from 'react-router-dom';
import { useStores } from 'stores/useStores';

import HeaderLoadingState from './HeaderLoadingState';

const SiteHeader = () => {
  const [unreadCount, setUnreadCount] = useState('');
  const {
    sessionStore: { sessionValid },
    userStore: { userProfile },
    testsStore: { petProfile },
  } = useStores();
  const isLoggedIn = sessionValid;

  const { siteHeader } = useLoadSiteHeader();
  const { promoBanner } = useLoadPromoBanner();
  const [amityStore] = useCreateAmityClient();

  const [params] = useSearchParams();
  const offerPage = useMatch('/offer');

  // TODO: remove feature flag before release
  const siteHeaderProps = useMemo(() => {
    if (!siteHeader) return null;

    const languageSwitcher = params.get('tpLangSwitcher') === 'true' ? siteHeader?.languageSwitcher : undefined;

    return { ...siteHeader, languageSwitcher };
  }, [params, siteHeader]);

  const context = useMemo(() => ({
    userProfile,
    petProfile,
    navigation: {
      messages: {
        unreadCount,
      },
    },
  }), [petProfile, unreadCount, userProfile]);

  usePatchLibUIComponentsContext(context);

  // Get total unread count for user
  useEffect(() => {
    const handleLiveObject = (liveObject: Amity.LiveObject<Amity.UserUnread | undefined>) => {
      const newUnreadCount = liveObject.data?.unreadCount || '';

      setUnreadCount(newUnreadCount < 100 ? newUnreadCount.toString() : '99+');
    };
    if (amityStore.client && amityStore.isConnected && isLoggedIn) {
      Client.getUserUnread(handleLiveObject);
    }
  }, [amityStore.client, amityStore.isConnected, isLoggedIn]);

  return (
    <>
      {siteHeaderProps ? <Header {...siteHeaderProps} className="header-lihp" /> : <HeaderLoadingState />}
      {offerPage ? null : <PromoBanner promoBanner={promoBanner} cssClass="header-promo-banner-lihp" />}
    </>
  );
};

export default observer(SiteHeader);
